import { djangoRedirectorPath } from '@framework/constants/routes';
import { createURLParams } from '@framework/utils/url';

export const sanitizeNextUrl = (nextParam: string, origin: string): string => {
    const nextURLObject = new URL(encodeURI(nextParam), origin);

    // avoid open redirects
    const shouldRedirectToPathInNextParam = nextURLObject.origin === origin;

    if (shouldRedirectToPathInNextParam) {
        return nextParam;
    }

    return djangoRedirectorPath;
};

export const redirectToAuthenticatedPath = (): void => {
    const nextParam = createURLParams().get('next');
    let nextURL = djangoRedirectorPath;

    if (nextParam) {
        const { origin } = window.location;
        nextURL = sanitizeNextUrl(nextParam, origin);
    }

    window.location.href = nextURL;
};
